module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-delete/user-delete.component.css
// module id = ./src/app/users/user-delete/user-delete.component.css
// module chunks = main